import React, { Component } from "react"
import "./Index.scss"
import DataChart from "./containers/DataChart"
import DataTable from "./containers/DataTable"
import overviewIcon from "app/styles/images/sp/overview-selected.svg"
import { observer, Provider } from "mobx-react"
import Store from "app/stores/pgd/dashboard"

@observer
export default class Index extends Component {
  constructor(props){
    super(props)
    this.store = new Store()
  }

  render() {
    return (
      <Provider store={this.store}>
        <div className="pgd">
          <h2 className="page-title"><img alt="" src={overviewIcon} />总览</h2>
          <DataChart />
          <DataTable />
        </div>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgd/dashboard/index.js